/** @jsx jsx */

import { Icon } from '@zapier/zinnia-icons';

import { jsx } from '@emotion/core';
import { Alert, AlertDescription, Button } from '@zapier/design-system';

type Props = {
  onClick: () => void;
};

/**
 * Renders the Error Block when documentation fails to fetch.
 * Allows the user to retry
 *
 * @param {object} props
 */
const ErrorBlock = (props: Props) => {
  return (
    <Alert status="warning" title="Oops!">
      <AlertDescription>
        We couldn‘t load this content for some reason.
      </AlertDescription>
      <Button iconPosition="start" onPress={props.onClick} variant="primary">
        <Icon name="arrowRefresh" />
        Try again
      </Button>
    </Alert>
  );
};

export default ErrorBlock;
